  <!-- @@User Timeline @@-->
  <!-- <app-profile-left></app-profile-left> -->
  <!--@@ START MIDDILE PART @@-->
  <div>
    <div id="timelineView" class="timeline-container" >
     <app-posting></app-posting>
    <!--  start feed filter -->
    <!-- <app-filter></app-filter> -->
    <!-- end feed filter -->
  
        <!--@@ Timeline Start@@ -->
  
        <div id="TimelineViewSingle">
  <div style="text-align:center">{{error_msg}}</div>
  <div *ngIf="funCollectionService.device_detail.is_desktop==true">
      <div *ngFor="let feedList of feedMixList; let index=index">
          <app-feed-card (deleteFeedIdx) = deleteFeedIdx($event) [feedObj]="feedList"  [feedIdx]="index" [ptoductType]="1"></app-feed-card>
      </div>
    </div>
      <div *ngIf="feed_id != undefined">
          <app-web-feed-detail   [feedId]="feed_id"></app-web-feed-detail>
        </div>
  </div>
    </div>
  
    <!-- <app-suggestion-list   ></app-suggestion-list> -->
  
  </div>
  
  <!--@@ END POST MIDDILE PART @@ -->
  
  <!-- @@ START RIGHT PART   @@-->
  <app-suggestion-right *ngIf="funCollectionService.device_detail.is_desktop==true" [product_type]=1></app-suggestion-right>
  <!-- @@ END RIGHT PART @@ -->
  <!--@@ END USER TIME LINE @@-->